module.exports = __webpack_public_path__ + "img/bar.d2c744fb.png";